import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_SUPABASE_URL: z.string().url("Invalid Supabase URL"),
    VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(1, "Supabase publishable key is required"),
  },
  // Listed one by one, so Vite inlines only these two values here.
  runtimeEnv: {
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_PUBLISHABLE_KEY: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  },
  emptyStringAsUndefined: true,
});
